import { render } from "./MusicSelector.vue?vue&type=template&id=a3639dba&ts=true"
import script from "./MusicSelector.vue?vue&type=script&lang=ts"
export * from "./MusicSelector.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__